import { BuildingSource } from '@visualizer/types';
import Triangle from '@data/geometry/Triangle';

export default class TrianglesReader {
    static read(reader, points, triangles, id = 0, buildingSource = BuildingSource.SWISSTOPO) {
        const numPntsSoFar = points.length;
        const K = reader.readUInt32();
        for (let i = 0; i < K; i++) {
            const point = reader.readVec3();
            points.push(point);
        }
        const T = reader.readUInt32();
        for (let i = 0; i < T; i++) {
            const A = reader.readInt32() + numPntsSoFar;
            const B = reader.readInt32() + numPntsSoFar;
            const C = reader.readInt32() + numPntsSoFar;
            var t = new Triangle();
            t.A = A;
            t.B = B;
            t.C = C;
            t.ID = id;
            t.buildingSource = buildingSource;
            triangles.push(t);
        }
        return T;
    }
}
